// Loads quicker than this show no loader at all.
export const CHAT_LOADING_DELAY = 300;

// A first load still going after this offers Retry.
export const CHAT_LOADING_SLOW = 5000;
